// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"2785d739","456":"a0f55f7e","459":"b90c8f9e","787":"a40efc1c","815":"49f3654e","879":"ebd39bb2","994":"459ec306"}[chunkId] + ".chunk.js";
};